<template>
  <div>
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="10">
          <v-card class="card--shadow mb-2">
            <v-card-text>
              <patient-info :patient="patient" />
            </v-card-text>
          </v-card>
          <v-card class="card--shadow">
            <del-person-list
              :patient_id="$route.params.patient_id"
              :delagatedPersons="delagatedPersons"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DelPersonList from "@/components/delagated-person/DelPersonList";
import PatientInfo from "../component/patientInfo.vue";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    DelPersonList,
    BackBtn,
    PatientInfo,
  },
  computed: {
    ...mapState("DelPerson", ["delagatedPersons"]),
    ...mapState("Patient", ["patient"]),
  },
  created() {
    this.$store.dispatch("DelPerson/getAll", this.$route.params.patient_id);
    this.$store.dispatch("Patient/getPatient", this.$route.params.patient_id);
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
